import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from '#src/shared/prefetch';

import type { ImpactPagePrefetchedDataProps } from '#src/app/pages/about/impact/pageContext';
import { ImpactPageContextProvider, prefetchPageContext } from '#src/app/pages/about/impact/pageContext';
import { OG_IMAGE } from '#src/app/pages/about/impact/shared/consts';

import { Layout } from '../layout';

import { ImpactErrorHandler } from './ErrorHandler';

export const Impact = withPrefetchedData(
	function Impact({ prefetchedData }: ImpactPagePrefetchedDataProps) {
		return (
			<ImpactPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={ImpactErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</ImpactPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
		pageTitle: ({ i18n, fromTemplate }) => fromTemplate(i18n.translate('fe.pages.about.title_tag')),
		pageMetadata: ({ i18n, getStaticAssetUrl }) => {
			const title = i18n.translate('fe.pages.about.title_tag');
			const description = i18n.translate('fe.pages.about.description_tag');
			return {
				description,
				ogTitle: title,
				ogDescription: description,
				ogImage: getStaticAssetUrl(OG_IMAGE),
				ogType: 'website',
				twitterCard: 'summary',
				twitterTitle: title,
				twitterDescription: description,
				twitterImage: getStaticAssetUrl(OG_IMAGE),
				twitterImageAlt: title,
			};
		},
	},
);
